import { render, staticRenderFns } from "./Enviar_para_aprobacion.vue?vue&type=template&id=69bc7975"
import script from "./Enviar_para_aprobacion.vue?vue&type=script&lang=js"
export * from "./Enviar_para_aprobacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports